module.exports = __webpack_public_path__ + "static/media/fb_icon.86ff47c6.svg";